import React, { createContext, useContext, useState, useEffect } from 'react';
import NotificationModal from '../components/harvester/scanner/NotificationModal';
import NotificationManager from '../utils/NotificationManager';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    isVisible: false,
    message: '',
  });

  const showNotification = (message) => {
    setNotification({
      isVisible: true,
      message,
    });
  };

  // Initialize NotificationManager with showNotification function
  useEffect(() => {
    NotificationManager.initialize(showNotification);
  }, []);

  const hideNotification = () => {
    setNotification({
      isVisible: false,
      message: '',
    });
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      <NotificationModal
        isVisible={notification.isVisible}
        message={notification.message}
        onClose={hideNotification}
      />
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};